import { render, staticRenderFns } from "./layer-assets-details-import.vue?vue&type=template&id=df9b3b16&scoped=true&"
import script from "./layer-assets-details-import.vue?vue&type=script&lang=js&"
export * from "./layer-assets-details-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b3b16",
  null
  
)

export default component.exports